var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonDeviceBiometrics = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M33.316 2H14.684C12.097 2 10 3.977 10 6.416v35.261c0 2.44 2.097 4.416 4.684 4.416h18.632c2.587 0 4.684-1.977 4.684-4.416V6.416C38 3.976 35.903 2 33.316 2z", fill: fills.light }),
        React.createElement("path", { d: "M24 42a1.995 1.995 0 110-3.992A1.995 1.995 0 1124 42z", fill: fills.dark }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.16 12.253a.776.776 0 000 1.55h2.056c.996 0 1.755.76 1.755 1.755v2.055c0 .427.345.772.772.772a.776.776 0 00.775-.774v-2.056a3.27 3.27 0 00-3.302-3.302H27.16zm-8.375 0a3.27 3.27 0 00-3.302 3.302v2.056c0 .427.348.774.775.774a.771.771 0 00.771-.772v-2.055c0-.995.76-1.756 1.756-1.756h2.055a.776.776 0 000-1.549h-2.055zm-2.528 11.912a.776.776 0 00-.775.774v2.056a3.27 3.27 0 003.302 3.302h2.056a.776.776 0 000-1.55h-2.056a1.723 1.723 0 01-1.755-1.755v-2.055a.771.771 0 00-.772-.772zm15.486 0a.771.771 0 00-.772.772v2.055c0 .994-.759 1.756-1.755 1.756H27.16a.776.776 0 000 1.549h2.056a3.27 3.27 0 003.302-3.302v-2.056a.776.776 0 00-.775-.774zm-9.923-5.079a2.185 2.185 0 114.37 0 2.185 2.185 0 01-4.37 0zm-1.556 3.702c.41-.41.965-.64 1.544-.64h4.383a2.183 2.183 0 012.183 2.183v.44a.873.873 0 01-.872.872h-6.999a.877.877 0 01-.877-.878v-.432c0-.58.23-1.135.638-1.545z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
